var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#D55555",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3222 18.1983C29.9364 15.2672 34.0657 15.2672 35.6778 18.1983L47.4517 39.5776C49.0342 42.4526 47.0022 46 43.776 46H20.2261C16.9977 46 14.9658 42.4526 16.5483 39.5776L28.3222 18.1983ZM34.11 39.5366C34.11 40.1082 33.8877 40.6564 33.492 41.0606C33.0963 41.4647 32.5596 41.6918 32 41.6918C31.4404 41.6918 30.9037 41.4647 30.508 41.0606C30.1123 40.6564 29.89 40.1082 29.89 39.5366C29.89 38.9651 30.1123 38.4169 30.508 38.0127C30.9037 37.6085 31.4404 37.3815 32 37.3815C32.5596 37.3815 33.0963 37.6085 33.492 38.0127C33.8877 38.4169 34.11 38.9651 34.11 39.5366ZM32 22.2953C31.4404 22.2953 30.9037 22.5223 30.508 22.9265C30.1123 23.3307 29.89 23.8788 29.89 24.4504V30.9159C29.89 31.4875 30.1123 32.0357 30.508 32.4399C30.9037 32.8441 31.4404 33.0711 32 33.0711C32.5596 33.0711 33.0963 32.8441 33.492 32.4399C33.8877 32.0357 34.11 31.4875 34.11 30.9159V24.4504C34.11 23.8788 33.8877 23.3307 33.492 22.9265C33.0963 22.5223 32.5596 22.2953 32 22.2953Z",
    fill: "#D55555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIndicator);
export default __webpack_public_path__ + "static/media/WarningIndicator.7afd559f69ddb72e9a11cd7fa6b67faa.svg";
export { ForwardRef as ReactComponent };